import { type Configuration, LogLevel } from '@azure/msal-browser'

export const EntraIDScopes = ['User.read', `api://${import.meta.env.VITE_CLIENT_ID}/user_impersonation`]
export const EntraIDLoginRequestScope = ['User.Read']

export const EntraIDAuthConfig: Configuration = {
	// required
	auth: {
		// must match info in dashboards
		clientId: import.meta.env.VITE_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`,
		knownAuthorities: [`https://login.microsoftonline.com/${import.meta.env.VITE_TENANT_ID}`],

		// login redirect; must match path in dashboard
		redirectUri: '/', // Must be registered as a SPA redirectURI on your app registration,
		postLogoutRedirectUri: '/', // Must be registered as a SPA redirectURI on your app registration
		navigateToLoginRequestUrl: true
	},

	cache: {
		cacheLocation: 'localStorage', //Needed to avoid 'login_required' error
		storeAuthStateInCookie: false //recommended to avoid certain IE/Edge issues.
	},

	// optional
	system: {
		loggerOptions: {
			logLevel: LogLevel.Warning,
			loggerCallback,
			piiLoggingEnabled: true
		}
	}
}

function loggerCallback(level: LogLevel, message: string, containsPii: boolean) {
	if (!containsPii) {
		const parts = message.split(' : ')
		const text = parts.pop()
		switch (level) {
			case LogLevel.Error:
				return console.error(text)

			case LogLevel.Warning:
				return console.warn(text)

			case LogLevel.Info:
				return console.info(text)

			case LogLevel.Verbose:
				return console.debug(text)

			case LogLevel.Trace:
				return console.trace(text)
		}
	}
}

export type { Configuration }
